import React from 'react';
import { createRoot } from 'react-dom/client';
import MoleculeComponent from './MoleculeComponent';

document.addEventListener('DOMContentLoaded', () => {
	const container = document.getElementById('molecule-app');
	const root = createRoot(container);
	root.render(<MoleculeComponent />);
});
